import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlayFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M27 16.0006C27.0008 16.3402 26.9138 16.6741 26.7473 16.9701C26.5808 17.266 26.3406 17.5138 26.05 17.6894L8.04 28.7069C7.73636 28.8928 7.38858 28.9943 7.0326 29.0009C6.67661 29.0075 6.32532 28.9189 6.015 28.7444C5.70764 28.5725 5.4516 28.3219 5.2732 28.0183C5.09481 27.7147 5.00051 27.369 5 27.0169V4.98437C5.00051 4.63223 5.09481 4.28658 5.2732 3.98296C5.4516 3.67935 5.70764 3.42873 6.015 3.25687C6.32532 3.08231 6.67661 2.99375 7.0326 3.00034C7.38858 3.00694 7.73636 3.10844 8.04 3.29437L26.05 14.3119C26.3406 14.4875 26.5808 14.7353 26.7473 15.0312C26.9138 15.3271 27.0008 15.6611 27 16.0006Z",
		fill: "white"
	})
});
export default SvgPlayFill;
